import Layout from "@/components/feature/Layout";
import ServicePage from "@/components/feature/ServicePage";

const data = {
  heroTitle: "Koltuk yıkama hizmeti",
  heroDescription: "Adana'da koltuk yıkama hizmetiyle koltuklarınızı derinlemesine temizletin, yaşam alanlarınızda hijyen ve ferahlık sağlayın.",
  description: "Koltuklar, ev ve iş yerlerinde en çok kullanılan eşyalardan biridir. Zamanla toz, leke ve kötü koku oluşabilir. Day Temizlik Adana, koltuk yıkama hizmetinde uygun ekipman ve dikkatli uygulama ile koltuklarınızı daha hijyenik ve ferah hale getirir. Koltuk yapısına uygun temizlik süreciyle derinlemesine temizlik sunuyoruz.",
  scope: [
    "Koltuk yüzey temizliği",
    "Derinlemesine yıkama",
    "Leke odaklı uygulama",
    "Koku ve kir oluşumuna karşı temizlik",
    "Ev ve iş yeri koltuklarına uygun hizmet",
  ],
  forWho: [
    "Ev sahipleri",
    "Ofis ve iş yeri sahipleri",
    "Kiracılar",
    "Restoran ve kafe işletmecileri",
    "Otel ve konaklama işletmeleri",
  ],
  process: [
    "Koltukların yapısı ve kumaş tipini değerlendiriyoruz.",
    "Leke ve kir yoğunluğunu belirleyerek uygun yöntemi seçiyoruz.",
    "Derinlemesine temizlik ve yıkama işlemini uyguluyoruz.",
    "Kuruma sürecini kontrol ediyoruz.",
    "Son kontrolü yaparak koltukları size teslim ediyoruz.",
  ],
  whyProfessional: [
    "Profesyonel ekipman koltuk yapısına zarar vermeden derinlemesine temizlik sağlar.",
    "Leke odaklı uygulama ile daha etkili sonuçlar alınır.",
    "Koku ve bakteri oluşumuna karşı hijyenik temizlik yapılır.",
    "Evde veya iş yerinde yerinde hizmet sayesinde pratik çözüm sunulur.",
    "Koltuklarınızın ömrü uzatılır.",
  ],
  relatedServices: [
    { title: "Halı Yıkama", path: "/hizmetlerimiz/hali-yikama" },
    { title: "Daire Temizliği", path: "/hizmetlerimiz/daire-temizligi" },
    { title: "Kuru Temizleme ve Ütü", path: "/hizmetlerimiz/kuru-temizleme-ve-utu" },
  ],
  faqs: [
    { question: "Koltuk yıkama hizmeti evde mi yapılır?", answer: "Evet, koltuk yıkama hizmeti ev veya iş yerinde yerinde yapılır." },
    { question: "Koltuk yıkama ne kadar sürer?", answer: "Koltuk sayısına ve kir yoğunluğuna göre değişir. Genellikle 1-2 saat sürer." },
    { question: "Koltuklar ne kadar sürede kurur?", answer: "Koltuk yapısına ve havalandırmaya göre 2-6 saat arasında kurur." },
  ],
  ctaText: "Koltuklarınız için hijyenik temizlik randevusu alın.",
  heroImage: "/assets/images/koltuk-yikama.jpg",
};

export default function KoltukYikamaPage() {
  return (
    <Layout>
      <ServicePage data={data} />
    </Layout>
  );
}